var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccordionMinus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 28,
    fill: "#006DEA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.0003 29.3307H20.0003C19.6467 29.3307 19.3076 29.1903 19.0575 28.9402C18.8075 28.6902 18.667 28.351 18.667 27.9974C18.667 27.6438 18.8075 27.3046 19.0575 27.0546C19.3076 26.8045 19.6467 26.6641 20.0003 26.6641H36.0003C36.3539 26.6641 36.6931 26.8045 36.9431 27.0546C37.1932 27.3046 37.3337 27.6438 37.3337 27.9974C37.3337 28.351 37.1932 28.6902 36.9431 28.9402C36.6931 29.1903 36.3539 29.3307 36.0003 29.3307Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccordionMinus);
export default __webpack_public_path__ + "static/media/accordion-minus.099a5b4e02dc73b757fcce8a40e90e15.svg";
export { ForwardRef as ReactComponent };